import { render, staticRenderFns } from "./DisplayNav.vue?vue&type=template&id=5c4ab0ed&"
import script from "./DisplayNav.vue?vue&type=script&lang=js&"
export * from "./DisplayNav.vue?vue&type=script&lang=js&"
import style0 from "./DisplayNav.vue?vue&type=style&index=0&id=5c4ab0ed&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports